/* ez-fc-filter — client-side pill filter for the grouped Shop All catalog (ez-faceted-catalog,
   group_by_type). Filters .ez-fc__card by data-fc-group / data-fc-format / data-fc-fit; AND across
   the three dimensions, single-select within each (click the active pill to clear it). Hides empty
   group sections and updates the count. No dependencies. */
(function () {
  var root = document.querySelector('[data-ez-fc-filter]');
  var grid = document.querySelector('[data-ez-fc-grid]');
  if (!root || !grid) return;

  var state = { group: '', format: '', fit: '' };
  var cards = [].slice.call(grid.querySelectorAll('.ez-fc__card'));
  var groups = [].slice.call(grid.querySelectorAll('.ez-fc__group'));
  var emptyEl = document.querySelector('[data-ez-fc-empty]');
  var countEl = document.querySelector('.ez-fc__count');

  function matches(card) {
    if (state.group && card.getAttribute('data-fc-group') !== state.group) return false;
    if (state.format && card.getAttribute('data-fc-format') !== state.format) return false;
    if (state.fit) {
      var fit = (card.getAttribute('data-fc-fit') || '').split(/\s+/);
      if (fit.indexOf(state.fit) === -1) return false;
    }
    return true;
  }

  function apply() {
    var visible = 0;
    cards.forEach(function (card) {
      var ok = matches(card);
      card.hidden = !ok;
      if (ok) visible++;
    });
    groups.forEach(function (g) {
      g.hidden = !g.querySelector('.ez-fc__card:not([hidden])');
    });
    if (emptyEl) emptyEl.hidden = visible !== 0;
    if (countEl) countEl.textContent = visible + (visible === 1 ? ' product' : ' products');
  }

  root.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('.ez-fc__pill');
    if (!pill) return;
    var dim = pill.getAttribute('data-fc-dim');
    var val = pill.getAttribute('data-fc-val') || '';
    state[dim] = state[dim] === val ? '' : val;
    var pills = root.querySelectorAll('.ez-fc__pill[data-fc-dim="' + dim + '"]');
    [].forEach.call(pills, function (p) {
      p.classList.toggle('is-active', (p.getAttribute('data-fc-val') || '') === state[dim]);
    });
    apply();
  });

  apply();
})();
